import { c as _c } from "react/compiler-runtime";
/**
 * @file UsersFilters.tsx
 * @description
 * -----------------------------------------------------
 * Componente de filtros y búsqueda de usuarios. Incluye
 * búsqueda por email y filtro de rol
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-12-11
 * @modified 2026-03-30
 * @author DLTCode
 * @author Sergio Manjón
 * @copyright © DLTCode
 * @license Private
 * */

import FormComponent from "@/components/ui/FormComponent";
import SearchComponent from "@/components/ui/SearchComponent";
import { DEFAULT_PAGE } from "@/constants/filters";
import { SEARCH_DEBOUNCE_TIME } from "@/constants/searchDebounceTime";
import { BaseFilters } from "@/enums/baseFilters.enum";
import useFilters from "@/hooks/useFilters";
import { Filters } from "@/types/filters";
import { useTranslations } from "next-intl";
import { useCallback, useState } from "react";
import { PlusIcon, Search } from "lucide-react";
import { UserRoles } from "..";
import SelectComponent from "@/components/ui/SelectComponent";
import ButtonComponent from "@/components/ui/ButtonComponent";
import AddUserModal from "./add-user-modal";
import styles from "./styles.module.scss";
const UsersFilters = t0 => {
  const $ = _c(41);
  const {
    showAddUserButton: t1
  } = t0;
  const showAddUserButton = t1 === undefined ? true : t1;
  const [filters, setFilters] = useFilters(BaseFilters.USERS);
  let t2;
  if ($[0] !== filters.mail || $[1] !== filters.role) {
    t2 = {
      mail: filters.mail,
      role: filters.role
    };
    $[0] = filters.mail;
    $[1] = filters.role;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [formData, setFormData] = useState(t2);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const placeHolders = useTranslations("Placeholders");
  const options = useTranslations("SelectComponent.Options");
  const labels = useTranslations("Labels");
  let t3;
  if ($[3] !== setFilters) {
    t3 = formData_0 => {
      setFilters({
        page: DEFAULT_PAGE,
        mail: formData_0.get("mail") as string,
        role: formData_0.get("role") as string
      });
    };
    $[3] = setFilters;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleSubmit = t3;
  let t4;
  if ($[5] !== formData.mail || $[6] !== setFilters) {
    t4 = value => {
      setFormData(prev => ({
        ...prev,
        role: value
      }));
      setFilters({
        page: DEFAULT_PAGE,
        mail: formData.mail as string,
        role: value
      });
    };
    $[5] = formData.mail;
    $[6] = setFilters;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleRoleChange = t4;
  let t5;
  if ($[8] !== placeHolders) {
    t5 = placeHolders("placeholderSearchEmail");
    $[8] = placeHolders;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== formData || $[11] !== handleSubmit || $[12] !== t5) {
    t6 = <SearchComponent formData={formData} setFormData={setFormData} onSearch={handleSubmit} searchAttribute="mail" placeholder={t5} debounceTime={SEARCH_DEBOUNCE_TIME} className={styles.adminSearch} />;
    $[10] = formData;
    $[11] = handleSubmit;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = formData.role;
  let t8;
  if ($[14] !== handleRoleChange) {
    t8 = e => handleRoleChange(e.target.value);
    $[14] = handleRoleChange;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== placeHolders) {
    t9 = placeHolders("placeholderRole");
    $[16] = placeHolders;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== labels) {
    t10 = labels("labelRole");
    $[18] = labels;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== options) {
    t11 = Object.values(UserRoles).map(role => ({
      value: role,
      label: options(role)
    }));
    $[20] = options;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== formData.role || $[23] !== t10 || $[24] !== t11 || $[25] !== t8 || $[26] !== t9) {
    t12 = <SelectComponent name="role" value={t7} onChange={t8} placeholder={t9} ariaLabel={t10} needLabel={false} options={t11} clearable={true} className={styles.adminSelect} />;
    $[22] = formData.role;
    $[23] = t10;
    $[24] = t11;
    $[25] = t8;
    $[26] = t9;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== showAddUserButton) {
    t13 = showAddUserButton && <ButtonComponent onClick={() => setIsOpenModal(true)} label="buttonAddUser" icon={PlusIcon} className="main__filters__action" />;
    $[28] = showAddUserButton;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== formData || $[31] !== handleSubmit || $[32] !== t12 || $[33] !== t13 || $[34] !== t6) {
    t14 = <FormComponent formData={formData} formAction={handleSubmit} buttonSubmit={false} buttonClassName="" formClassName="main__filters" buttonSubmitText="buttonFilter" icon={Search}>{t6}{t12}{t13}</FormComponent>;
    $[30] = formData;
    $[31] = handleSubmit;
    $[32] = t12;
    $[33] = t13;
    $[34] = t6;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== isOpenModal) {
    t15 = isOpenModal && <AddUserModal isOpen={isOpenModal} onClose={() => setIsOpenModal(false)} />;
    $[36] = isOpenModal;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== t14 || $[39] !== t15) {
    t16 = <div>{t14}{t15}</div>;
    $[38] = t14;
    $[39] = t15;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  return t16;
};
export default UsersFilters;